import { Link } from "react-router-dom";
import { getHotMovies } from "@/utils/movie";

export default function HotRanking() {
  const list = getHotMovies(6);
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 pb-4 md:pb-8">
      <div className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-7">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-fire-fill text-primary-500"></i>
            本周热度榜
          </h2>
          <Link
            href="/category?sort=heat"
            to="/category?sort=heat"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1 whitespace-nowrap"
          >
            完整榜单
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {list.map((m: any, i: number) => (
            <Link
              key={m.id}
              href={`/detail/${m.id}`}
              to={`/detail/${m.id}`}
              className="group flex items-center gap-3 p-2.5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="w-8 shrink-0 text-center font-heading text-xl font-bold text-primary-500/70 group-hover:text-primary-500">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="w-11 h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={m.poster}
                  alt={`${m.title} 海报`}
                  title={`${m.title} 剧情介绍`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {m.title}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-500 truncate">
                  {m.type} · {m.year}
                </p>
                <p className="mt-1 text-xs text-accent-700 font-medium inline-flex items-center gap-1">
                  <i className="ri-fire-line"></i>
                  {m.heat}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}